"use strict";
import { scopeDropdownItem, scopeGeoLayer } from "./../ui";
import geoStore from "../stores/geoStore";
import pointStore from "../stores/pointStore";
import configStore from "../stores/configStore";
import polylabel from "polylabel";
import _ from "lodash";
export default class GeoScope {
  constructor({ geoScope }) {
    this.data = geoScope;
    this.markers_group = [];
    this.menuItem = null;
    this.menuItemRepaint = () => {
    };
  }
  get activeState() {
    return { fillColor: "#2952A370", color: "#2952A3" };
  }
  isEmpty(points = void 0) {
    if (this.data.geom === null) return true;
    if (!points) points = pointStore.getState().points;
    const currentScopeId = this.id;
    return !points.find(({ geoScopeId }) => `${geoScopeId}` === `${currentScopeId}`);
  }
  isLoading() {
    return pointStore.getState().isLoading;
  }
  get staledState() {
    return { fillColor: "#cccccc", color: "#999999" };
  }
  select() {
    const { selectedScope: previousScope } = geoStore.getState();
    if (previousScope === this) return;
    geoStore.getState().selectScope(this);
  }
  /**
   * If the current marker is selected (active)
   * @returns boolean
   */
  isActive() {
    const { selectedScope } = geoStore.getState();
    if (selectedScope) return selectedScope.id === this.id;
    return false;
  }
  repaint() {
    var _a, _b;
    if (this.isActive()) {
      (_a = this.layer) == null ? void 0 : _a.setStyle(this.activeState);
    } else {
      (_b = this.layer) == null ? void 0 : _b.setStyle(this.staledState);
    }
  }
  get name() {
    return this.data.name.translation;
  }
  get geom() {
    return this.data.geom;
  }
  get id() {
    return parseInt(`${this.data.id}`);
  }
  nodesForScope() {
    const { points } = pointStore.getState();
    const currentScopeId = this.id;
    return points.filter(({ geoScopeId }) => `${geoScopeId}` === `${currentScopeId}`).filter(Boolean);
  }
  markersForScope() {
    if (this.markers_group.length > 0) return this.markers_group;
    return this.nodesForScope().filter((node) => node.isGeoLocated()).map(({ marker }) => marker);
  }
  componentIds() {
    return _.uniq(
      this.nodesForScope().map(({ data }) => data.componentId ? `${data.componentId}` : false).filter(Boolean)
    );
  }
  scopeClickHandler() {
    this.select("layer");
  }
  remove() {
    const { map } = configStore.getState();
    if (this.layer && map.hasLayer(this.layer)) {
      try {
        map.removeLayer(this.layer);
      } catch (e) {
        console.error(e);
      }
    }
  }
  init(scopeLayer) {
    var _a;
    this.markers_group = this.markersForScope();
    const [itm, repaintItm] = scopeDropdownItem({
      scopeId: this.id,
      label: this.name,
      onClick: () => {
        geoStore.getState().selectScope(this);
        this.repaint();
      }
    });
    this.menuItem = itm;
    this.menuItemRepaint = repaintItm;
    if ((_a = this.data.geom) == null ? void 0 : _a.type) {
      if (this.data.geom.type === "MultiPolygon") {
        this.centroid = polylabel(this.data.geom.coordinates[0], 1);
      }
      this.layer = scopeGeoLayer({
        geoScope: this.data,
        centroid: this.centroid,
        onClick: this.scopeClickHandler.bind(this)
      });
      this.layer.bringToBack();
      let layers = scopeLayer.getLayers();
      if (layers.length > 0) {
        let scopeId = this.id.toString();
        let ids = [];
        scopeLayer.eachLayer((layer) => {
          layer.eachLayer((layer2) => {
            ids.push(layer2.feature.geometry.properties.id);
          });
        });
        if (!ids.includes(scopeId)) {
          scopeLayer.addLayer(this.layer);
        }
      } else {
        scopeLayer.addLayer(this.layer);
      }
      pointStore.subscribe(
        (state) => [state.isLoading],
        ([isLoading]) => {
          const { map, mapReady } = configStore.getState();
          if (isLoading) return;
          if (this.isEmpty() && this.layer) {
            if (map.hasLayer(this.layer) && mapReady) {
              map.removeLayer(this.layer);
            }
          }
        }
      );
    }
    this.repaint();
    return this;
  }
}
